import { isString, isValid } from "@visactor/vutils";

import { BandScale, LinearScale, OrdinalScale, PointScale, ThresholdScale } from "@visactor/vscale";

import { ColorOrdinalScale } from "../scale/color-ordinal-scale";

const defaultScaleMap = {
    linear: LinearScale,
    band: BandScale,
    point: PointScale,
    ordinal: OrdinalScale,
    threshold: ThresholdScale,
    colorOrdinal: ColorOrdinalScale
};

export function createScale(type) {
    const scaleConstructor = defaultScaleMap[type];
    return scaleConstructor ? new scaleConstructor : null;
}

export function createScaleWithSpec(spec, context) {
    if ("scale" in spec && spec.scale) return isString(spec.scale) && (null == context ? void 0 : context.globalScale) ? context.globalScale.registerMarkAttributeScale(spec, context.seriesId) : spec.scale;
    const scale = createScale(spec.type);
    return scale && initScaleWithSpec(scale, spec), scale;
}

function initScaleWithSpec(scale, spec) {
    scale && spec && (spec.domain && scale.domain(spec.domain), spec.range && scale.range(spec.range), 
    spec.specified && scale.specified && scale.specified(spec.specified));
}

export function valueInScaleRange(v, s) {
    if (!s) return v;
    const range = s.range(), min = Math.min(range[0], range[range.length - 1]), max = Math.max(range[0], range[range.length - 1]);
    return Math.min(Math.max(min, v), max);
}

export function isSpecValueWithScale(specValue) {
    return isValid(null == specValue ? void 0 : specValue.field) && isValid(null == specValue ? void 0 : specValue.scale);
}
//# sourceMappingURL=scale.js.map
